import { render } from "./BalancePage.vue?vue&type=template&id=bc2f2e4c"
import script from "./BalancePage.vue?vue&type=script&lang=js"
export * from "./BalancePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__